import React, { useMemo } from 'react';
import Hint from '@storeblocks/hint';
import Popover from '@storeblocks/popover';
import { SingleBase, Box, Label, LabelText } from './styled';
import Icon from './icon';
function Single({ id, name, label, value, onChange, checked = false, indeterminate = false, disabled = false, hint, info, inputProps, labelProps, hintProps, popoverProps, }) {
    const labelId = `labeledby-id_${id}`;
    const ariaChecked = useMemo(() => {
        if (indeterminate)
            return 'mixed';
        if (checked)
            return 'true';
        return 'false';
    }, [checked, indeterminate]);
    function handleChange(event) {
        if (!disabled) {
            onChange(event);
        }
    }
    function renderLabel() {
        return (React.createElement(React.Fragment, null,
            React.createElement("input", Object.assign({ type: "checkbox", id: id, name: name, value: value, onChange: handleChange, checked: checked, "aria-checked": ariaChecked, "aria-disabled": disabled, "aria-labelledby": labelId }, inputProps)),
            React.createElement(Label, Object.assign({ id: labelId, htmlFor: id, "aria-disabled": disabled }, labelProps),
                React.createElement(Icon, { checked: checked, indeterminate: indeterminate, disabled: disabled }),
                label.length > 0 && React.createElement(LabelText, null, label))));
    }
    function renderInfo() {
        return info && React.createElement(Popover, Object.assign({}, popoverProps), info);
    }
    function renderHint() {
        return hint && React.createElement(Hint, Object.assign({}, hintProps), hint);
    }
    return (React.createElement(SingleBase, null,
        React.createElement(Box, null,
            renderLabel(),
            renderInfo()),
        renderHint()));
}
export default Single;
